export enum HERO_TYPE {
  CENTRE,
  STATIC,
}

export type HeroTypeStrings = keyof typeof HERO_TYPE;
